import { useEffect } from "react";

/**
 * Generic JSON-LD injector. Appends a <script type="application/ld+json">
 * containing the supplied schema object to the document tree, then removes
 * it on unmount. Identified by data-jsonld="<key>" so multiple hooks can
 * coexist without stomping on each other and the prerender pass can find
 * exactly what it captured.
 *
 * The script is appended to #root (not <head>) so the prerender snapshot —
 * which serialises #root — picks it up. Google parses ld+json from
 * anywhere in the document.
 */
export default function useJsonLd(key, schema) {
    useEffect(() => {
        if (!schema) return;

        const el = document.createElement("script");
        el.type = "application/ld+json";
        el.setAttribute("data-jsonld", key);
        el.textContent = JSON.stringify(schema);

        const host = document.getElementById("root") || document.head;
        host.appendChild(el);

        return () => {
            if (el.parentNode) el.parentNode.removeChild(el);
        };
    }, [key, schema]);
}
